import React, {
  useState,
  useEffect,
} from 'react';

import './CoursesInPlace.css';

import bazeleconta from '../../../images/bazeleconta.png';
import contafinanciaraone from '../../../images/contafinanciara.png';
import contaprimara from '../../../images/contaprimara.png';
import contabilitateaplicata from '../../../images/contabilitateaplicata.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


const mockCourses = [
  {
    id: 1,
    name: 'Bazele contabilitatii',
    description: 'Fundamentele contabilitatii pe intelesul tuturor.',
    status: 'active',
    icon: bazeleconta,
    color: 'teal',
  },
  {
    id: 2,
    name: 'Contabilitate financiara',
    description: 'Invata sa inregistrezi si sa intelegi operatiunile financiare.',
    status: 'development',
    icon: contafinanciaraone,
    color: 'orange',
  },
  {
    id: 3,
    name: 'Contabilitate primara',
    description: 'Invata documentele si operatiunile contabile de baza.',
    status: 'development',
    icon: contaprimara,
    color: 'green',
  },
  {
    id: 4,
    name: 'Contabilitate aplicata',
    description: 'Aplica notiunile contabile in situatii practice si exercitii.',
    status: 'development',
    icon: contabilitateaplicata,
    color: 'purple',
  },
];


export default function CoursesInPlace() {

  const [enrolledCourses, setEnrolledCourses] = useState(() => {
    const saved = localStorage.getItem('enrolledCourses');

    if (saved) {
      try {
        const parsed = JSON.parse(saved);

        return Array.isArray(parsed)
          ? parsed.map(Number)
          : [1];
      } catch {
        return [1];
      }
    }

    return [1];
  });


  /* =====================================================
     SALVEAZA CURSURILE ACTIVE
  ===================================================== */

  useEffect(() => {
    localStorage.setItem(
      'enrolledCourses',
      JSON.stringify(enrolledCourses)
    );

    window.dispatchEvent(
      new CustomEvent('coursesUpdated', {
        detail: enrolledCourses,
      })
    );
  }, [enrolledCourses]);


  /* =====================================================
     ADAUGA / ELIMINA CURS
  ===================================================== */

  const handleToggleEnroll = (event, courseId) => {
    event.stopPropagation();

    const numericCourseId = Number(courseId);

    const course = mockCourses.find(
      (item) => item.id === numericCourseId
    );

    if (!course || course.status !== 'active') {
      return;
    }

    setEnrolledCourses((currentCourses) => {
      if (currentCourses.includes(numericCourseId)) {
        return currentCourses.filter(
          (id) => id !== numericCourseId
        );
      }

      return [
        ...currentCourses,
        numericCourseId,
      ];
    });
  };


  /* =====================================================
     SELECTARE CURS
  ===================================================== */

  const handleCourseClick = (course) => {
    if (!course || course.status !== 'active') {
      return;
    }

    const courseId = Number(course.id);

    if (![1, 2, 3, 4].includes(courseId)) {
      return;
    }

    if (!enrolledCourses.includes(courseId)) {
      setEnrolledCourses((currentCourses) => {
        if (currentCourses.includes(courseId)) {
          return currentCourses;
        }

        return [
          ...currentCourses,
          courseId,
        ];
      });
    }

    localStorage.setItem(
      'selectedCourseId',
      String(courseId)
    );

    window.dispatchEvent(
      new CustomEvent('courseSelected', {
        detail: courseId,
      })
    );
  };


  return (
    <div className="courses-page-layout">

      <main className="courses-page-main">

        {/* =====================================================
            HEADER
        ===================================================== */}

        <div className="coursesinplace-header">

          <h1>
            Cursurile mele
          </h1>

          <p>
            Alege cursul pe care vrei sa il continui.
          </p>

        </div>


        {/* =====================================================
            GRID CURSURI
        ===================================================== */}

        <div className="coursesinplace-grid">

          {mockCourses.map((course) => {

            const isEnrolled =
              enrolledCourses.includes(course.id);

            const isActive =
              course.status === 'active';

            const isDevelopment =
              course.status === 'development';

            const canClick =
              isActive;

            const colorClass =
              course.color
                ? `color-${course.color}`
                : '';


            return (

              <div
                key={course.id}

                className={[
                  'coursesinplace-card',

                  isActive
                    ? 'current'
                    : '',

                  isDevelopment
                    ? 'development'
                    : '',

                  colorClass,

                ]
                  .filter(Boolean)
                  .join(' ')}

                onClick={() => {
                  if (canClick) {
                    handleCourseClick(course);
                  }
                }}

                role="button"

                tabIndex={
                  canClick
                    ? 0
                    : -1
                }

                onKeyDown={(event) => {
                  if (
                    canClick &&
                    (
                      event.key === 'Enter' ||
                      event.key === ' '
                    )
                  ) {
                    event.preventDefault();

                    handleCourseClick(course);
                  }
                }}

                style={{
                  cursor:
                    canClick
                      ? 'pointer'
                      : 'default',
                }}
              >

                {/* =====================================================
                    BADGE CURS
                ===================================================== */}

                {isDevelopment ? (

                  <div className="coursesinplace-development-badge">
                    In dezvoltare
                  </div>

                ) : isEnrolled ? (

                  <button
                    type="button"
                    className="coursesinplace-current-badge"

                    onClick={(event) =>
                      handleToggleEnroll(
                        event,
                        course.id
                      )
                    }

                    aria-label={`Elimina ${course.name} din cursurile mele`}
                    title="Elimina cursul"
                  >

                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7 10L9 12L13 8"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                  </button>

                ) : (

                  <button
                    type="button"
                    className="coursesinplace-add-badge"

                    onClick={(event) =>
                      handleToggleEnroll(
                        event,
                        course.id
                      )
                    }

                    aria-label={`Adauga ${course.name} in cursurile mele`}
                    title="Adauga cursul"
                  />

                )}


                {/* =====================================================
                    IMAGINE
                ===================================================== */}

                <div
                  className={[
                    'coursesinplace-card-icon',

                    isActive
                      ? 'current'
                      : '',

                    isDevelopment
                      ? 'development'
                      : '',

                    colorClass,

                  ]
                    .filter(Boolean)
                    .join(' ')}
                >

                  <img
                    src={course.icon}
                    alt={course.name}
                    className="coursesinplace-course-image"
                  />

                </div>


                {/* =====================================================
                    CONTINUT CURS
                ===================================================== */}

                <div className="coursesinplace-card-content">

                  <div
                    className={[
                      'coursesinplace-card-title',

                      isActive
                        ? 'current'
                        : '',

                      isDevelopment
                        ? 'development'
                        : '',

                    ]
                      .filter(Boolean)
                      .join(' ')}
                  >
                    {course.name}
                  </div>

                  <div className="coursesinplace-card-description">
                    {course.description}
                  </div>

                </div>


                {/* =====================================================
                    SAGEATA
                ===================================================== */}

                {isActive && (

                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="coursesinplace-card-arrow"
                    aria-hidden="true"
                  />

                )}

              </div>

            );

          })}

        </div>

      </main>

    </div>
  );
}